import { z } from "zod";

export const qlikFieldSchema = z.object({
  name: z.string(),
  tags: z.array(z.string()),
});

export type QlikField = z.infer<typeof qlikFieldSchema>;

export const listQlikFieldsResponseSchema = z.object({
  data: z.array(qlikFieldSchema),
});

export type ListQlikFieldsResponse = z.infer<typeof listQlikFieldsResponseSchema>;
